import api from '@/sui/api/api'
import delay from '@/sui/api/delay'

let module = null

const remote = true
if (remote) {
  module = {
    get (request) {
      return api.post('dataset/get', request)
    },

    computeAllDatasetsResults () {
      return api.post('dataset/computeall', {})
    },

    isDatasetComputing () {
      return api.post('dataset/computingstat', {})
    },

    transform (request) {
      return api.post('dataset/transform', request)
    },

    complete (request) {
      return api.post('dataset/complete', request)
    },

    all (request) {
      return api.post('dataset/all', request)
    },

    sheets (request) {
      return api.post('/dataset/sheets', request)
    },

    names (request) {
      return api.post('/dataset/names', request)
    },

    removeByName (request) {
      return api.post('/dataset/removeByName', request)
    },

    copy (request) {
      return api.post('/dataset/copy', request)
    }
  }
} else {
  module = {

    get (request) {
      return delay(1500)({
        data: {
          err: 'Erreur au chargement.'
        }
      })
    }
  }
}

export default module
